/**
 * ProductDetailContainer
 * --
 */
import { useLocation, useParams } from 'react-router-dom';
import { useGetProduct } from 'hooks/ProductHooks';
import ProductDetailPresenter from './ProductDetailPresenter';

/**----------------------------------------
 * [Component] 상품상세정보: 컨테이너
 * ----------------------------------------
 */
const ProductDetailContainer = ({ defaultProductId }) => {
  const { productId } = useParams();
  const { data: response } = useGetProduct(
    defaultProductId ?? productId,
    {
      join_tables: '["product_category", "product_file"]',
    },
    {
      select: (res) => {
        const { status, data } = res;
        if (status !== 200) return null;
        return data;
      },
      initialData: null,
      enabled: productId || defaultProductId ? true : false,
    },
  );
  const location = useLocation();

  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProductDetailPresenter
        productData={response}
        searchLocation={location.search}
      />
    </>
  );
};

ProductDetailContainer.defaultProps = {
  defaultProductId: null,
};
export default ProductDetailContainer;
